import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/lib/supabase";
import { CreditCard } from "lucide-react";

const STRIPE_PUBLISHABLE_KEY = 'pk_test_51OOhIVFGS9T5vOCcU6IjsTI6arxgZyRsIKsTJRaCAUDDbaepx5WqugAMdf2Y3bCA2fLth5Z3XoS0ARYPec6JBVZf006DDdN5GN';

const PACKAGES = [
  {
    id: 'price_1QSzFeFGS9T5vOCcOr7Evrkw',
    tokens: 1000,
    price: '20€',
    description: '1000 Token Package',
    image: '/lovable-uploads/085e3ebc-1393-40f5-b9be-99ad2d5089b6.png'
  },
  {
    id: 'price_1QSzETFGS9T5vOCcE4GqHwwc',
    tokens: 500,
    price: '11€',
    description: '500 Token Package',
    image: '/lovable-uploads/cc8df7f0-9954-43b1-a2d4-4e982158e965.png'
  },
  {
    id: 'price_1QUR9yFGS9T5vOCc1uGVaUq8',
    tokens: 200,
    price: '5€',
    description: '200 Token Package',
    image: '/lovable-uploads/daf30a3a-ee56-4633-9226-b737c54b6f33.png'
  }
];

export const TokenPurchase = () => {
  const { toast } = useToast();

  const handlePurchase = async (priceId: string) => {
    try {
      console.log('Initiating purchase for price ID:', priceId);
      
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        toast({
          title: "Authentication Required",
          description: "Please sign in to purchase tokens.",
          variant: "destructive",
        });
        return;
      }

      const { data, error } = await supabase.functions.invoke('create-checkout', {
        body: { priceId },
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        }
      });

      if (error) throw error;
      if (!data?.url) throw new Error('No checkout URL received');

      console.log('Redirecting to checkout URL:', data.url);
      window.location.href = data.url;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      toast({
        title: "Error",
        description: "Failed to initiate purchase. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {PACKAGES.map((pkg) => (
        <Card key={pkg.id} className="p-6 flex flex-col justify-between">
          <div>
            <h3 className="text-xl font-bold text-center">{pkg.description}</h3>
            <div className="mt-2 flex justify-center">
              <img 
                src={pkg.image} 
                alt={`${pkg.tokens} Tokens Package`}
                className="h-44 w-44 object-contain"
              />
            </div>
            <p className="text-muted-foreground mt-3 text-center">{pkg.price}</p>
          </div>
          <Button 
            className="mt-4 w-full" 
            onClick={() => handlePurchase(pkg.id)}
          >
            Purchase
          </Button>
        </Card>
      ))}
    </div>
  );
};